import { devLog } from './devLogger';

async function checkServer(url: string) {
  try {
    // For development, skip the server check to avoid CORS issues during local development
    if (process.env.NODE_ENV === "development") {
      devLog.log('Skipping server check in development mode');
      return true;
    }

    // In production, make a simple GET request without custom headers to avoid CORS preflight
    const response = await fetch(url, {
      method: 'GET',
      mode: "cors",
      cache: 'no-cache',
    });

    devLog.log('Server check response:', response.status);

    if (response.ok) {
      // Server is available
      return true;
    } else if (response.status === 404) {
      throw new Error(`Server responded with status: ${response.status}`);
    } else {
      throw new Error(`Server responded with status: ${response.status}`);
    }
  } catch (error: unknown) {
    // Check if the error is a CORS error or network error
    if (error instanceof Error) {
      throw new Error(`Failed to reach server: ${error.message}`);
    } else {
      throw new Error('Unknown error occurred.');
    }
  }
}

export default checkServer;
